<div class="layout-header px-3 py-2 border-bottom d-flex justify-content-between align-items-center">
  <div class="header-right d-flex justify-content-center align-items-center">
    <div class="search-bar position-relative d-flex align-items-center">
      <img src="assets/images/icons/hamburger-menu.svg" alt="" class="d-xl-none me-3" (click)="openNavMenu()">

      <!-- Subscription's back arrow. It belongs to the bar rather than to each
           screen, so it can never sit over Create Contract — see
           subscriptionBackTarget for where each page returns to. -->
      @if (subscriptionBackTarget) {
        <button type="button" class="topnav-back me-3" aria-label="Back" (click)="goSubscriptionBack()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M15 18l-6-6 6-6" />
          </svg>
        </button>
      }
      <!-- <div class="d-flex w-100 input_field p-0 overflow-hidden">
      <input type="text" class="input_field py-1 pe-3 flex-fill m-0 border-0 border-end right-tb-border remove "
        placeholder="Search Here" [(ngModel)]="search_string" (blur)="emitSearch()" (change)="emitSearch()">

        <img src="assets/images/icons/cross-icon.svg" alt="" (click)="clearSearch()" class="cursor px-2"
          *ngIf="search_string">

        </div> -->
      </div>
    </div>
    <div class="header-left d-flex justify-content-center align-items-center position-relative">
      <div
        [tooltip]="(userProfile?.role_id !=5 || userProfile?.role_id !='5' ? userProfile?.is_approved !=1 && userProfile?.is_approved !=2 : agentData?.is_approved !='1' && agentData?.is_approved !='2') ? 'Your account has been disapproved. Please contact support for further assistance.' : ''">
        @if (!showDebtBtn && _shared.hasFinanceCustomer && !hideCreateContractBtn ) {
          <button class="btn btn-secondary fs-16 fw-700 me-3"
            [disabled]="(userProfile?.role_id !=5 || userProfile?.role_id !='5' ? userProfile?.is_approved !=1 && userProfile?.is_approved != 2 : agentData?.is_approved !='1' && agentData?.is_approved !='2')"
            [routerLink]="'/app/finance/finance-customer'">
            Create Contract
          </button>
        }
      </div>
      <div
        [tooltip]="(userProfile?.role_id !=5 || userProfile?.role_id != '5' ? userProfile?.is_approved != 1 && userProfile?.is_approved != 2 : agentData?.is_approved != '1' && agentData?.is_approved != '2') ? 'Your account has been disapproved. Please contact support for further assistance.' : ''">
        @if (showDebtBtn) {
          <button
            [disabled]="(userProfile?.role_id !=5 || userProfile?.role_id != '5' ? userProfile?.is_approved != 1 && userProfile?.is_approved != 2 : agentData?.is_approved != '1' && agentData?.is_approved != '2')"
            [routerLink]="'/app/debt-recovery/start-recovery'"
            class="fs-14 fw-700 p-2 border  text-primary border-primary radius-8 bg-white d-flex justify-content-between align-items-center cursor me-3"
            [ngClass]="{'opacity-half' : (userProfile?.role_id !=5 || userProfile?.role_id != '5' ? userProfile?.is_approved != 1 && userProfile?.is_approved != 2 : agentData?.is_approved != '1' && agentData?.is_approved != '2')}">
            + Recover Debt
          </button>
        }
      </div>
      <!-- <img src="assets/images/icons/active-bolt.svg" alt="" class="me-3" *ngIf="_shared.showEarlyPayoutBadge.value == true"> -->
      <span class="position-relative me-3">
        <img src="assets/images/icons/bell-icon.svg" alt="" class="notify-bell rounded-circle border cursor"
          (click)="_main.showNotificationBar = true">
          @if (_main.unread_count > 0) {
            <span
              class="position-absolute bg-danger text-white rounded-circle fs-12 hw-21 d-flex align-items-center justify-content-center text-center p-1"
              style="top: -8px;right: -14px;" [ngClass]="{ 'hw-26' :  _main.unread_count && _main.unread_count > 99}"
              >
              {{_main.unread_count && _main.unread_count > 99 ? '99+' : _main.unread_count}}
            </span>
          }
        </span>

        <img
          [src]="_shared.doctorProfileImage || (userProfile?.role_id == 5 ? (agentData?.doctor_image?.includes('profile_placeholder') ? 'assets/images/icons/profile_placeholder.png' : agentData?.doctor_image) : ( userProfile?.doctor_image?.includes('profile_placeholder') ? 'assets/images/icons/profile_placeholder.png' : userProfile?.doctor_image )) || 'assets/images/icons/profile_placeholder.png'"
          [ngClass]="{'rounded-circle': !_shared.doctorProfileImage && (!userProfile?.doctor_image || userProfile?.doctor_image?.includes('profile_placeholder')) && (!agentData?.doctor_image || agentData?.doctor_image?.includes('profile_placeholder'))}"
          alt="" class="profile-icon cursor" (click)="showLogoutModal()"
          (error)="onProfileImageError($event)">

          <!-- it is using for user image in user manage and doctor image in doctor profile -->
          <!-- <img
          [src]="_shared.doctorProfileImage || (userProfile?.role_id == 5 ? (userProfile?.agent_image?.includes('profile_placeholder') ? 'assets/images/icons/profile_placeholder.png' : userProfile?.agent_image) : ( userProfile?.doctor_image?.includes('profile_placeholder') ? 'assets/images/icons/profile_placeholder.png' : userProfile?.doctor_image )) || 'assets/images/icons/profile_placeholder.png'"
          [ngClass]="{'rounded-circle': !_shared.doctorProfileImage && (!userProfile?.doctor_image || userProfile?.doctor_image?.includes('profile_placeholder')) && (!userProfile?.agent_image || userProfile?.agent_image?.includes('profile_placeholder'))}"
          alt="" class="profile-icon cursor" (click)="showLogoutModal()"> -->


          @if (showLogout) {
            <div class="logout-wrapper p-4 position-absolute bg-white end-0 radius-16" style="z-index: 999;">
              <div class="logout-header d-flex align-items-center border-bottom pb-4 mb-4 lhc">
                <img
                  [src]="_shared.doctorProfileImage || (userProfile?.role_id == 5 ? (agentData?.doctor_image?.includes('profile_placeholder') ? 'assets/images/icons/profile_placeholder.png' : agentData?.doctor_image) : ( userProfile?.doctor_image?.includes('profile_placeholder') ? 'assets/images/icons/profile_placeholder.png' : userProfile?.doctor_image )) || 'assets/images/icons/profile_placeholder.png'"
                  alt="" class="business-img me-3 lhc radius-4"
                  [ngClass]="{'rounded-circle': !_shared.doctorProfileImage && (!userProfile?.doctor_image ||  userProfile?.doctor_image?.includes('profile_placeholder') ) && (!agentData?.doctor_image || agentData?.doctor_image?.includes('profile_placeholder'))}" />
                  <div class="lhc">
                    <h1 class="fs-16 fw-600 m-0 lhc">
                      {{ userProfile?.role_id == 5 ? userProfile?.agent_name : userProfile?.doctor_name }}
                    </h1>
                    <p class="fs-14 fw-400 m-0 lhc">
                      {{ userProfile?.role_id == 4 ? (userProfile?.email_verified === 2 ? userProfile?.doctor_email :'') : userProfile?.agent_email}}
                    </p>
                  </div>
                </div>
                @if (userProfile?.email_verified === 0 || userProfile?.email_verified === 1 ) {
                  <div  class="verification mb-3 py-3 px-3 radius-8" style="background-color: rgba(242, 247, 255, 1); border: 1px solid rgba(206, 226, 255, 1);">
                    <p class="mb-1 fs-14 fw-800">⚠️Verify Your Email Address</p>
                    <span class="fs-14 fw-400" style="color:rgba(0, 70, 175, 1);">{{userProfile?.doctor_email}}</span>
                    <button (click)="openEmailModal()" class="btn btn-secondary py-2 px-3 mt-2 fs-12 fw-700">{{userProfile?.email_verified === 1 ? 'Resend Link' : 'Verify Now'}}</button>
                  </div>
                }
                <div class="logout-body">
                  @if (userProfile && userProfile?.role_id) {
                    <ul class="p-0">
                      @for (item of settingsList; track item; let i = $index) {
                        @if (item.shoAction) {
                          <li class="d-flex align-items-center mb-3 cursor" (click)="userAction(item)">
                            <img [src]="item.icon" alt="" class="rounded-circle me-3">
                            <p class="fs-14 fw-600 m-0">
                              {{item.label}}
                            </p>
                          </li>
                        }
                      }
                    </ul>
                  }
                </div>
                <div class="logout-footer d-flex align-items-center pt-3 border-top mt-3">
                  <img src="assets/images/icons/logout.svg" alt="" class="rounded-circle me-3 cursor" (click)="logoutModal()">
                  <p class="fs-14 fw-600 m-0 cursor " (click)="logoutModal()">
                    Logout
                  </p>
                </div>
              </div>
            }
          </div>
        </div>